import React from 'react';
import { useAuthStore } from '../../store/authStore';
import { LogOut } from 'lucide-react';

export const Header: React.FC = () => {
  const logout = useAuthStore((s) => s.logout);

  return (
    <header className="flex items-center justify-between px-4 py-3 bg-gray-800 border-b border-gray-700">
      <h1 className="text-lg font-semibold text-white">
        PixiJS Editor
      </h1>
      <button
        onClick={logout}
        className="btn btn-secondary flex items-center gap-2 px-4 py-2 text-sm"
      >
        <LogOut size={18} />
        Log Out
      </button>
    </header>
  );
};
